
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14cnr_8aic2_9",
  "trigger": "awsui_trigger_14cnr_8aic2_43",
  "dropdown": "awsui_dropdown_14cnr_8aic2_46",
  "nowrap": "awsui_nowrap_14cnr_8aic2_57",
  "open": "awsui_open_14cnr_8aic2_60"
};
  